/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Createdutc1Inputs */

const en_entity_createdutc1 = /** @type {(inputs: Entity_Createdutc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created (UTC)`)
};

const de_entity_createdutc1 = /** @type {(inputs: Entity_Createdutc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt (UTC)`)
};

/**
* | output |
* | --- |
* | "Created (UTC)" |
*
* @param {Entity_Createdutc1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_createdutc1 = /** @type {((inputs?: Entity_Createdutc1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Createdutc1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_createdutc1(inputs)
	return de_entity_createdutc1(inputs)
});
export { entity_createdutc1 as "entity_createdUtc" }